module.exports = __webpack_public_path__ + "static/media/list_cn.1924a4dc.png";